export default __webpack_public_path__ + "9a20887c9db70ee5c9727600f8710bbe.wav";